module.exports = __webpack_public_path__ + "df5c5b958a7202efd2e703efc2d4de7f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/vercetti.jpg
// module id = 732
// module chunks = 0